import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMove = props => (
  <SvgIcon {...props} viewBox="0 0 24 20">
    <path d="m9.6 0 2.4 2.5h9.6c1.32 0 2.4 1.125 2.4 2.5v12.5c0 1.375-1.08 2.5-2.4 2.5h-19.2c-1.32 0-2.4-1.125-2.4-2.5l0.012-15c0-1.375 1.068-2.5 2.388-2.5h7.2zm4.898 15.58 1.436 1.42 6.066-6-6.066-6l-1.4358 1.4201 3.6083 3.5687h-8.106v2.0223h8.106l-3.6083 3.5687z" />
  </SvgIcon>
);

export default IconMove;



// WEBPACK FOOTER //
// ./src/components/icons/IconMove.js